import { Avatar, Box, Text, TooltipCommonProps } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { AIFilled } from '@wix/wix-ui-icons-common';
import React, { FC } from 'react';

import { TLocalesKeys } from '../../../../../types';
import { headerFullPageDataHooks } from '../HeaderFullPage.dataHooks';

const titleTooltipProps: TooltipCommonProps = {
  size: 'small',
  placement: 'bottom',
};

interface FullPageTitleProps {
  isLiveChat: boolean;
  isConnectingAgent: boolean;
  agent?: { fullName: string; profileImage?: string };
}

export const FullPageTitle: FC<FullPageTitleProps> = ({ isLiveChat, isConnectingAgent, agent }) => {
  const { t } = useTranslation();

  return (
    <Box direction="vertical" gap="0.5">
      <Text size="tiny" weight="thin" light dataHook={headerFullPageDataHooks.title()}>
        {t<TLocalesKeys>('subheader_title')}
      </Text>
      {isLiveChat && agent ? (
        <Box gap="0.5" verticalAlign="middle">
          <Avatar
            size="size24"
            shape="square"
            name={agent.fullName}
            imgProps={{ src: agent.profileImage }}
            dataHook={headerFullPageDataHooks.agentAvatar()}
          />
          <Text
            light
            weight="bold"
            ellipsis
            tooltipProps={titleTooltipProps}
            dataHook={headerFullPageDataHooks.secondaryTitle()}
          >
            {agent.fullName}
          </Text>
        </Box>
      ) : (
        <Box gap="0.5" verticalAlign="middle">
          {isConnectingAgent ? (
            <Text light weight="bold">
              {t<TLocalesKeys>('header_title_connecting_agent')}
            </Text>
          ) : (
            <>
              <Text light>
                <Box>
                  <AIFilled />
                </Box>
              </Text>
              <Text light weight="bold">
                {t<TLocalesKeys>('widget_title_ai_chatbot')}
              </Text>
            </>
          )}
        </Box>
      )}
    </Box>
  );
};
